import { render, staticRenderFns } from "./ypanachorisi.vue?vue&type=template&id=6fef3a22"
import script from "./ypanachorisi.vue?vue&type=script&lang=js"
export * from "./ypanachorisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports